import moment from 'moment';
export default {
  install(Vue) {
    Vue.filter('videoposter', (value) => {
      if (!value) return;
      let url = value.split('?')[0];
      let len = url.split('.').length;
      let type = url.split('.')[len - 1];
      const arr = ['jpg', 'png', 'jpeg', 'gif'];
      if (
        ~arr.findIndex((row) => {
          return row == type;
        })
      ) {
        return url;
      }else{
        //可能是多个图片的集合
        try{
            var value = JSON.parse(value);
            return value[0];
        }catch{

        }
      }
      return `${url}?x-oss-process=video/snapshot,t_1000,f_jpg,ar_auto`;
    });
    Vue.filter('date', (val) => {
      let date = new Date(val * 1000);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + '/' + month + '/' + day;
    });
    Vue.filter('fromunixtime', (Value) => {
      return moment(Value * 1000).format('YYYY-MM-DD HH:mm:ss');
    });
    Vue.filter('fromunixtime1', (Value) => {
      if(!Value) return '- -'
      return moment(Value * 1000).format('MM/DD HH:mm:ss');
    });
    Vue.filter('diffentTime', (diffValue, Value) => {
      if(!Value) return '- -'

      if (diffValue < 0) {
        console.log('时间不对劲,服务器创建时间与当前时间不同步');
        return '刚刚';
      }
      if (diffValue < 60) {
        return '刚刚';
      }
      let dur = moment.duration(diffValue * 1000);
      if (diffValue > 60 && diffValue < 3600) {
        return dur.minutes() + '分钟前';
      }

      if (diffValue > 3600 && diffValue < 86400) {
        return dur.hours() + '小时前';
      }
      return moment(Value * 1000).format('MM-DD HH:mm');
    });



    Vue.filter('Timetype',(value)=>{
      var d,
        h,
        m,
        s
      if (value >= 0) {
        d = Math.floor(value / 60 / 60 / 24);
        h = Math.floor((value / 60 / 60) % 24);
        m = Math.floor((value / 60) % 60);
        s = Math.floor(value % 60);
      }
      if (d) {
        return d + '天' + h + ':' + m +':' + s;
      } else if (h) {
        // return d + "天" + h + "小时" + m + "分" + s + "秒";
        return h + ':' + m +':' + s;
      } else if (m) {
        return m +':' + s;
      } else {
        return s;
      }
    })
    Vue.filter('SportsItemtype',(value)=>{
      switch(+value){
        case 2:
          return '个';
          break;
        default:
          return '';
          break;
      }
    })


  },
};
